module.exports = __webpack_public_path__ + "img/nav1.f4635b2f.png";